import dynamic from 'next/dynamic';

export const JsonFormReviewModal = dynamic(
  () =>
    import('./json-form-review/json-form-review-modal').then(
      (mod) => mod.JsonFormReviewModal
    ),
  { ssr: false, loading: () => null }
);

export const JsonFormEditModal = dynamic(
  () =>
    import('./json-form-edit/json-form-edit-modal').then((mod) => mod.JsonFormEditModal),
  { ssr: false, loading: () => null }
);
